import dayjs from "dayjs";
import { useState } from "react";

import useDispatchStore from "@web-app/store/dispatchStore";
import { timeZoneMap } from "@web-app/utils/helpers";

export const useTimezone = () => {
  const { user } = useDispatchStore();

  const [isHovering, setIsHovering] = useState(false);

  const getTimezone = (timezone: keyof typeof timeZoneMap | undefined) => {
    return timezone || user?.timezone || "system";
  };

  const convertToTimezone = (date: Date, timezone: string) => {
    if (timezone === "system") return date;

    // Treat the input date as UTC and convert to target timezone
    const dateTz = dayjs.utc(date).tz(timezone).toDate();

    return dateTz;
  };

  const getTimezoneValue = (timezone: keyof typeof timeZoneMap | undefined) => {
    if (timezone && timezone !== "system") {
      return dayjs().tz(timezone).format("z");
    }

    return "";
  };

  const userTimezone = user?.timezone || "system";

  return {
    convertToTimezone,
    getTimezone,
    getTimezoneValue,
    isHovering,
    setIsHovering,
    userTimezone,
  };
};
